import { useMemo } from "react";
import { Trans } from "react-i18next";
import type { InstanceDataSet } from "../../../api/threads/liveMessages";
import { ABoxView, proposedStatements, type UnrecordedInstanceData } from "../../knowledgeData";
import { DocumentVersionName } from "../../sources";
import { ContentVersionName } from "../../versions";
import { useThreadContext } from "../page/threadPageContext";

/**
 * A step's instance data in the Run (knowledge-data.md K-9), in the one instance-data view, the
 * regest (F154), under the document and the data model version it was written against.
 */
export default function InstanceDataOutput({ output, entry }: { output: InstanceDataSet; entry: number | undefined }) {
  const { overview, threadId } = useThreadContext();
  return (
    <div className="space-y-2">
      <p className="text-sm">
        <Trans
          i18nKey="threads.output.instanceDataAbout"
          components={{ document: <DocumentVersionName reference={output.document} />, model: <ContentVersionName projectId={overview.projectId} reference={output.model} /> }}
        />
      </p>
      <ProposedInstanceData set={output} entry={entry === undefined ? null : `${threadId}#${String(entry)}`} projectId={overview.projectId} />
    </div>
  );
}

/** A set not recorded as a result, as the instance-data view draws it; asked about as the entry that holds it where there is one. */
export function ProposedInstanceData({ set, entry, projectId }: { set: InstanceDataSet; entry: string | null; projectId: string }) {
  const subject = useMemo((): UnrecordedInstanceData => ({
    source: entry ?? set.document,
    projectId: entry === null ? undefined : projectId,
    document: set.document,
    model: set.model,
    accepted: false,
    instanceStatements: proposedStatements(set),
  }), [set, entry, projectId]);
  return <ABoxView extraction={subject} />;
}
